<template>
<div class="promotion-reward-selector-component">
  <div v-if="visible"
       class="promotion-reward-selector-anchor bg-primary-light p-4 rounded-t cursor-pointer fixed right-0 bottom-0 mr-4 shadow-lg md:transition duration-300 transform hover:scale-110"
       @click="navigateToRewardSelectionPage"
  >
    <h4 class="text-dark-darker">
      Выбрать подарок
      <i class="fal fa-gift"></i>
    </h4>
  </div>
</div>
</template>

<script>
export default {
  props: {
    promotionId: {
      required: true,
      type: String,
    },

    rewardId: {
      required: true,
      type: String,
    },

    maxQuantity: {
      required: true,
      type: Number,
    },

    context: {
      required: false,
      type: Object,
      default: null,
    },

    label: {
      required: false,
      type: String,
      default: 'Выберите подарок',
    },
  },

  computed: {
    visible() {
      return this.$route.name !== 'promotions.rewards'
    }
  },

  methods: {
    navigateToRewardSelectionPage() {
      if (this.$route.name === 'promotions.rewards') {
        return
      }

      const query = {}

      if (this.context) {
        query.context_type = this.context.type
        query.context_id = this.context.id
      }

      this.$router.push({
        query,
        name: 'promotions.rewards',
        params: {
          promotionId: this.promotionId,
          rewardId: this.rewardId,
        },
      })
    },
  },
}
</script>
